import { getTracking } from '@moda/portal-astrarium';
import { dictionary } from './portalDictionary';

export const tc = getTracking(dictionary);
